import { getIn } from "formik";
import React from "react";

import { getAutomationDataAttr } from "@/utils/automationUtils";
import { Input, Text, TextColors, TextTypes } from "@/component-library";
import { testLocator } from "@/lib/helpers/test-locator";

import "./CredentialField.styles.scss";

export const CredentialField = ({ formikProps, isViewOnly, name, testId }) => {
  const errorMessage = getIn(formikProps.errors, name);
  const isTouched = getIn(formikProps.touched, name);
  const value = formikProps.values[name];

  const handleChange = async (event) => {
    await formikProps.setFieldValue(name, event.target.value);
  };

  return (
    <div className="CredentialField--wrapper">
      <div className="CredentialField--title_wrapper">
        <h3 className="CredentialField--title">Credentials</h3>
      </div>

      <div className="CredentialField--input_wrapper">
        {isViewOnly && (
          <p
            className="CredentialField--view_only_input"
            {...getAutomationDataAttr(testId)}
            {...testLocator(testId)}
          >
            {value === "" ? "None" : value}
          </p>
        )}

        {!isViewOnly && (
          <>
            <Input
              disabled={true}
              inputClassName="CredentialField--input tw:size-min!"
              onChange={handleChange}
              value={formikProps.values[name]}
            />

            {errorMessage && isTouched && (
              <Text color={TextColors.red} layout="block" type={TextTypes.small}>
                {errorMessage}
              </Text>
            )}
          </>
        )}
      </div>
    </div>
  );
};
